<form
  class="flex flex-col items-stretch justify-around gap-2"
  [formGroup]="configForm"
>
  <div class="flex items-center gap-3">
    <mat-form-field class="flex-1">
      <mat-label>Name</mat-label>
      <input type="text" matInput formControlName="name" [required]="true" />
    </mat-form-field>
    <mat-form-field class="flex-1">
      <mat-label>Keyword</mat-label>
      <input type="text" matInput formControlName="keyword" />
      <mat-hint>
        Set a unique keyword to make finding this treatment easier
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="flex items-center gap-3">
    <mat-form-field class="flex-1">
      <mat-label>Treatment Category</mat-label>
      <input
        type="text"
        matInput
        formControlName="category"
        [matAutocomplete]="categoryAutoComplete"
      />
      <mat-autocomplete
        #categoryAutoComplete="matAutocomplete"
        class="category-select-panel"
        [displayWith]="displayCategoryFn"
      >
        <mat-option
          *ngFor="let category of treatmentCategories; trackBy: trackByRef"
          [value]="category"
        >
          <div class="flex items-center gap-2">
            <span
              class="h-3 w-3 rounded-full"
              [style.backgroundColor]="category.colour.value"
            >
            </span>
            {{ category.name }}
          </div>
        </mat-option>
      </mat-autocomplete>
      <button
        *ngIf="configForm.value.category"
        matIconSuffix
        mat-icon-button
        (click)="clearCategory()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label>Duration (minutes)</mat-label>
      <input
        type="number"
        matInput
        formControlName="duration"
        [required]="true"
      />
    </mat-form-field>
  </div>

  <mat-form-field class="flex-1">
    <mat-label>Description</mat-label>
    <input
      type="text"
      matInput
      formControlName="description"
      [required]="true"
    />
  </mat-form-field>
</form>
